module.exports = __webpack_public_path__ + "static/media/ShareImage.a15cd319.png";